let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1F8cZ")).then(() => parcelRequire('4k3HM'));